export default {
  h1: `START BY DOING GOOD`,
  h2: `Select a featured charity`,
  h3: `Pledge your donation to one of our featured charities.`,
  note: `Remember, your credit card is only charged if a mutual match is made!`,
  actions: {
    info: ` Learn more`,
    select: `Select`
  }
};



// WEBPACK FOOTER //
// ./assets/strings/select.js